import { AppAreaConfig } from '@/funnels/@types'
import fastingFemale from '../fasting/female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-high-protein-fwf',
	landing: {
		ids: ['loader-f-high-protein'],
		route: {
			path: '/high-protein-f',
			name: 'female-high-protein-funnel',
		},
	},
	funnel: {
		id: 'ob-female-high-protein-fwf',
		route: {
			path: '/high-protein-f/ob/:page*',
			name: 'female-high-protein-fwf',
		},
		slug: 'female-high-protein-fwf',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: fastingFemale,
				page: 'target-zones',
			},
		},
	},
}

export default appAreaConfig
